// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"format-vertical-align-left"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 5H21M3 12H15M3 19H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FormatVerticalAlignLeftIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'format-vertical-align-left',
    ref,
    icon: element,
  },
));

FormatVerticalAlignLeftIcon.displayName = 'FormatVerticalAlignLeftIcon';

export default FormatVerticalAlignLeftIcon;
